<template>
  <div style="font-weight: bold; padding-bottom: 10px">
    <label
      class="el-form-item__label"
      :style="labelWidth ? `width: ${labelWidth};` : ''"
      >{{ label }}</label
    >
    <div
      class="el-form-item__content"
      :style="labelWidth ? `margin-left: ${labelWidth};` : ''"
    >
      <el-row type="flex" justify="space-between" :gutter="gutter">
        <el-col :span="prependSpan"> <slot name="prepend"></slot> </el-col>
        <el-col :span="24 - prependSpan - appendSpan"> <slot></slot> </el-col>
        <el-col :span="appendSpan"> <slot name="append"></slot></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    labelWidth: String,
    gutter: { type: Number, default: 0 },
    prependSpan: { type: Number, default: 0 },
    appendSpan: { type: Number, default: 0 },
  },
};
</script>

<style></style>
